import { truthItems } from '@/mocks/home';

export default function TruthVault() {
  return (
    <section id="truth" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">实锤合集</h2>
            <p className="mt-1 text-sm text-foreground-600">监控、录音、截图、旧照，一条线索就是一块石头</p>
          </div>
          <a
            href="#feed"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 hover:bg-background-200"
          >
            查看全部合集
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {truthItems.map((item) => (
            <a
              key={item.label}
              href="#feed"
              className="group relative block h-64 overflow-hidden rounded-lg border border-background-200 md:h-72"
            >
              <img
                src={item.cover}
                alt={item.title}
                title={item.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="cover-shade absolute inset-0"></div>
              <span className="absolute left-4 top-4 font-heading text-2xl font-bold text-accent-400">{item.label}</span>
              <span className="absolute right-4 top-4 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-medium text-foreground-800">
                实锤
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-white md:text-lg">{item.title}</h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-200 md:text-sm">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}